import React from "react"
import { Provider } from "react-redux"
import { createStore as reduxCreateStore } from "redux"
import { rootReducer } from "."

export const createStore = () => reduxCreateStore(rootReducer)

export default ({ children }) => (
  <Provider store={createStore()}>{children}</Provider>
)